import { useTranslation } from 'react-i18next';

import {
  BankSelect,
  FormControls,
  FormikArray,
  PaymentTypeSelect,
} from 'components';
import { TranslationNamespace } from 'i18n';

export const SciPaymentTypeConfigs: React.FC = () => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.shops.manage',
  });

  return (
    <FormikArray
      addItemLabel={t('buttons.add_sci_payment_type')}
      name="sciPaymentConfigs"
      removable
      defaultValue={{ paymentTypeId: '', bankId: '' }}
      ItemComponent={({ item, index }) => (
        <FormControls sx={{ flex: 1 }}>
          <PaymentTypeSelect
            name={`sciPaymentConfigs[${index}].paymentTypeId`}
            label={t('fields.sci_payment_type')}
            fullWidth
            required
          />
          <BankSelect
            label={t('fields.sci_payment_bank')}
            name={`sciPaymentConfigs[${index}].bankId`}
            noneOption
          />
        </FormControls>
      )}
    />
  );
};
